<template>
    <div class="screenshots">
        <div v-if="items.length > 0" class="space-y-6">
            <!-- Pills -->
            <div class="flex items-center justify-center flex-wrap gap-2 mb-6">
                <button
                    v-for="(item, index) in items"
                    :key="index"
                    @click="activeIndex = index"
                    class="cursor-pointer border px-4 py-2 text-sm font-medium transition-colors rounded-full"
                    :class="[
                        activeIndex === index
                            ? (isLight ? 'border-neutral-600 text-neutral-800' : 'border-white text-white')
                            : [
                                'border-transparent',
                                isLight ? 'text-neutral-600' : 'text-neutral-300'
                            ]
                    ]"
                >
                    {{ item.title || `Screenshot ${index + 1}` }}
                </button>
            </div>

            <!-- Screenshots (all eager loaded, only active one visible) -->
            <div class="w-full relative">
                <div
                    v-for="(item, index) in items"
                    :key="index"
                    class="rounded-lg overflow-hidden border-8 border-opacity-20 transition-opacity duration-300 aspect-16/9"
                    :class="[
                        isLight ? 'border-neutral-200 bg-neutral-400' : 'border-neutral-900 bg-neutral-700',
                        activeIndex === index ? 'opacity-100 relative' : 'opacity-0 absolute inset-0 pointer-events-none'
                    ]"
                >
                    <img
                        :src="item.image"
                        :alt="item.title || `Screenshot ${index + 1}`"
                        class="w-full h-auto object-cover"
                        loading="eager"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Screenshots',
    data() {
        return {
            activeIndex: 0,
        };
    },
    props: {
        items: {
            required: true,
            type: Array,
            default: () => [],
        },
        bgColor: {
            type: String,
            default: null,
        },
        isLight: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">

</style>

